export const STOCK_STATUS = {
    STOCK: 'Stock',
    OUT_OF_STOCK: 'Out Of Stock',
    NOT_LAUNCHED: 'Not Launched'
}

